<template>
    <form-row title="Earnest Money Recieved?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_received_earnest_money"
                v-model="has_received_earnest_money"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_received_earnest_money"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Received:"
                :value="commercial.earnest_money_received_at"
                name="earnest_money_received_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_received_earnest_money: this.commercial.has_received_earnest_money,
        }
    },
}
</script>
